import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useRef, useState } from 'react'
import Alert from 'react-bootstrap/Alert'
import Breadcrumb from '../components/Breadcrumb'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import { Helmet } from 'react-helmet'
import Spinner from '../components/Spinner'
import classNames from 'classnames'
import { confirmForgotPassword } from '../store/auth'
import { initialize } from '../store/pagedata'
import queryString from 'query-string'
import styles from '../styles/signin.module.scss'
import useDarkMode from 'use-dark-mode'
import { useLocation } from 'react-router-dom'

const ConfirmPassword = () => {
  const error = useSelector((state) => state.auth.error)
  const isLoading = useSelector((state) => state.auth.isLoading)
  const success = useSelector((state) => state.auth.success)
  const { search } = useLocation()
  const darkMode = useDarkMode(false)
  const dispatch = useDispatch()
  const ref = useRef()
  const { oobCode } = queryString.parse(search)
  const [code, setCode] = useState(oobCode)
  const [newPassword, setNewPassword] = useState()

  useEffect(() => {
    ref.current.focus()
    dispatch(initialize())
  }, [])

  const onSubmit = async (e) => {
    e.preventDefault()
    dispatch(confirmForgotPassword(code, newPassword))
    setNewPassword('')
  }

  return (
    <>
      <Helmet>
        <meta name='description' content='EDHREC Forgot Password' />
        <meta name='keywords' content='EDHREC,forgot,password' />
        <title>Confirm Password | EDHREC</title>
      </Helmet>
      <Breadcrumb breadcrumb={[{ '/confirm-password': 'Confirm Password' }]} />
      <h1 className='page-heading'>Confirm Password</h1>
      <div
        className={classNames(styles.container, {
          [styles.dark]: darkMode.value,
        })}
      >
        <div className={styles.containerInner}>
          <h2 className={styles.header}>Confirm Password</h2>
          <form onSubmit={onSubmit}>
            <Form.Group>
              <Form.Label>Code</Form.Label>
              <Form.Control
                onChange={(e) => setCode(e.target.value)}
                placeholder='Code'
                type='text'
                value={code}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>New Password</Form.Label>
              <Form.Control
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder='New Password'
                ref={ref}
                type='password'
                value={newPassword}
              />
            </Form.Group>
            <Form.Group>
              <Button
                className='btn-block'
                disabled={isLoading}
                type='submit'
                variant='primary'
              >
                {isLoading ? <Spinner /> : 'Submit'}
              </Button>
            </Form.Group>
            <Form.Group>
              {error && <Alert variant='danger'>{error}</Alert>}
              {success && <Alert variant='success'>{success}</Alert>}
            </Form.Group>
          </form>
        </div>
      </div>
    </>
  )
}

export default ConfirmPassword
